import { Badge } from '@chakra-ui/react'

import { Flex, Text } from '@chakra-ui/react'

import { InsuranceProvider, PopulatedPregnancyPlan, WithId } from '@hb/shared'

import { InsuranceCoverage } from '@hb/shared'
import { useMemo } from 'react'

export const InsuranceCoveragePreview = ({
  plan,
  allInsuranceProviders,
  noBadge = false,
  size = 'sm',
}: {
  plan: InsuranceCoverage | null
  allInsuranceProviders: WithId<InsuranceProvider>[]
  noBadge?: boolean
  size?: 'sm' | 'md' | 'lg'
}) => {
  const insurer = allInsuranceProviders.find(p => p.id === plan?.insuranceProviderId)

  const nameSize = useMemo(() => {
    if (size === 'sm') return 'md'
    if (size === 'md') return 'lg'
    return 'xl'
  }, [size])

  const memberIdSize = useMemo(() => {
    if (size === 'sm') return 'sm'
    if (size === 'md') return 'md'
    return 'lg'
  }, [size])

  const badge = useMemo(() => {
    const asPregnancyPlan = plan as PopulatedPregnancyPlan
    if (asPregnancyPlan.pregnancyLabel) {
      return asPregnancyPlan.pregnancyLabel
    }
    if (plan?.id === 'primary') {
      return 'Primary'
    } else if (plan?.id === 'secondary') {
      return 'Secondary'
    } else {
      return 'Potential'
    }
  }, [plan])
  const memberIdText = useMemo(() => {
    if (plan?.memberId) return plan.memberId
    if (plan?.noMemberId) return 'No Member ID yet'
    return 'Missing member ID'
  }, [plan])

  return (
    <Flex w="100%" gap={2} pr={2} pl={1} align="center">
      <Flex flexFlow="column" flex={1} minW="0">
        {insurer && (
          <Text lineHeight={1} fontWeight={600} color="gray.600" fontSize={nameSize}>
            {insurer.name}
          </Text>
        )}
        <Text lineHeight={1} color="gray.500" fontSize={memberIdSize}>
          {memberIdText}
        </Text>
      </Flex>
      {!noBadge && badge ? (
        <Badge ml="auto" colorScheme="green" variant="solid">
          {badge}
        </Badge>
      ) : null}
    </Flex>
  )
}
